<template>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-12 faqs mb-5" v-for="(faq, count) in faqGroups" :key="count">
                <h5 class="faqs-title" v-if="faq.faqs && faq.faqs.length > 0"> {{ faq.group_name }}</h5>
                <div :id="'accordion'+count" @click="focusOnAccordion('accordion'+count)">
                    <div class="card" v-for="(list, index) in faq.faqs" :key="index">
                        <a class="collapsed card-link" data-toggle="collapse" :href="'#collapse'+count+index">
                            <div class="card-header arrow">
                                {{ list.question }}
                            </div>
                        </a>
                        <div :id="'collapse'+count+index" class="collapse" :data-parent="'#accordion'+count">
                            <div class="card-body" v-html="list.answer">
                                {{ list.answer }}                    
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Helper from '../../../../helper'
 
    export default {
        computed: {
            faqGroups() {
                return this.$store.getters.GET_FAQS_CONTENT.list; 
            }
        },
        mounted() {
            this.$store.dispatch('faqGroups');
        },
        methods : {
            focusOnAccordion(elementId){
                // setTimeout(function() {
                //     var element = document.getElementById(elementId)
                //     if ( element ){
                //         Helper.scrollIntoView(element)
                //     }
                // }, 500);
            }
        }
    }
</script>